import React from 'react';
import { CHECKOUT_MESSAGES } from '../../constants/checkout';
import { toMarketingUrl } from '../../constants/siteDomains';
interface CheckoutTermsAcceptanceProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
}

const CheckoutTermsAcceptance: React.FC<CheckoutTermsAcceptanceProps> = ({
  checked,
  onChange,
  id = 'checkout-terms',
}) => {
  const { terms } = CHECKOUT_MESSAGES;

  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 transition-colors hover:border-[#5C528A]/30"
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-gray-300 text-[#5C528A] focus:ring-[#5C528A]"
        required
      />
      <span className="text-sm leading-relaxed text-gray-700">
        {terms.prefix}{' '}
        <a
          href={toMarketingUrl('/termos-de-servico')}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#5C528A] underline decoration-[#5C528A]/30 underline-offset-2 hover:text-[#4A4070]"
          onClick={(e) => e.stopPropagation()}
        >
          {terms.termsLink}
        </a>{' '}
        {terms.and}{' '}
        <a
          href={toMarketingUrl('/politica-de-privacidade')}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#5C528A] underline decoration-[#5C528A]/30 underline-offset-2 hover:text-[#4A4070]"
          onClick={(e) => e.stopPropagation()}
        >
          {terms.privacyLink}
        </a>
        .
      </span>
    </label>
  );
};

export default CheckoutTermsAcceptance;
